// src/utils/escalationHelper.ts
import { LocalAuthority } from '../types/compliance';

const escalationMap = {
  [LocalAuthority.WAKEFIELD]: {
    hub: 'Social Care Direct',
    phone: '0345 8 503 503',
    framework: 'Connecting Care Quality Framework (CCQF Audit Dashboard)',
    legalBasis: 'Care Act 2014 Sec 42',
  },
  [LocalAuthority.LEEDS]: {
    hub: 'Adult Social Care',
    phone: '0113 222 4401',
    framework: 'Leeds Quality Assurance Framework (QAF Compliance Matrix)',
    legalBasis: 'Health & Social Care Act 2008 (Regulated Activities)',
  },
  [LocalAuthority.BRADFORD]: {
    hub: 'Adult Services Access Point',
    phone: '01274 435400',
    framework: 'Provider Assessment & Market Management Solution (PAMMS Portal)',
    legalBasis: 'Mental Capacity Act 2005',
  },
  [LocalAuthority.KIRKLEES]: {
    hub: 'Gateway to Care',
    phone: '01484 414933',
    framework: 'Kirklees Quality Monitoring Framework (KQMF Key Performance Modules)',
    legalBasis: 'Human Rights Act 1998',
  },
};

export function getEscalationDetails(localAuthority: LocalAuthority) {
  return escalationMap[localAuthority] || null;
}